/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_1_AInputs */

const en_mk_how_1_a = /** @type {(inputs: Mk_How_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your idea, pick a starter kit (QRIS POS, WhatsApp OTP, Supabase RLS, booking, capstone), or connect a codebase`)
};

const id_mk_how_1_a = /** @type {(inputs: Mk_How_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan idemu, pilih starter kit (kasir QRIS, WA OTP, Supabase RLS, booking, capstone), atau sambungkan codebase`)
};

/**
* | output |
* | --- |
* | "Describe your idea, pick a starter kit (QRIS POS, WhatsApp OTP, Supabase RLS, booking, capstone), or connect a codebase" |
*
* @param {Mk_How_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_1_a = /** @type {((inputs?: Mk_How_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_1_a(inputs)
	return en_mk_how_1_a(inputs)
});